import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, } from '@material-ui/core';
import MTabsButton from '../../view/MTabsButton';
import MTabPanel from '../../view/MTabPanel';
import { MovieIndexRaqiu, MovieIndexOuzhi, MovieIndexJqs } from '.';
import Apis from '../../../network/Apis';
import MatchType from '../../../model/MatchType';

class MovieIndex extends React.Component {

    constructor(props) {
        super(props);
        this.state = { value: 0, data: null }
        console.log('MovieIndex', props);
    }

    componentDidMount() {
        this.getIndex();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getIndex = async () => {
        let reuslt = await Apis.encryptionGetHistory(this.props.data.match_type, this.props.data.match_id);
        console.log(reuslt);
        if (reuslt.code == 200) {
            this.setState({ data: reuslt.data });
        }
    }

    _handleChange = (val) => {
        this.setState({ value: val });
    }

    render() {
        const { classes } = this.props;
        const { value, data } = this.state;
        let match_type = MatchType.FOOTBALL;
        if (this.props && this.props.location && this.props.location.data) {
            match_type = this.props.location.data.match_type;
        }
        return (
            <Grid container direction='column' alignItems='center' justify='center' className={classes.root}>
                <Grid container direction='column' alignItems='center' justify='center' style={{ marginTop: 16, marginBottom: 16 }}>
                    <MTabsButton data={['欧指', '让球', '进球数']} onChange={(val) => this._handleChange(val)} />
                </Grid>
                <Grid>
                    <MTabPanel value={value} index='0' style={{ width: '100vw' }}>
                        <MovieIndexOuzhi data={data} matchType={match_type} />
                    </MTabPanel>
                    <MTabPanel value={value} index='1' style={{ width: '100vw' }}>
                        <MovieIndexRaqiu data={data} matchType={match_type} />
                    </MTabPanel>
                    <MTabPanel value={value} index='2' style={{ width: '100vw' }}>
                        <MovieIndexJqs data={data} matchType={match_type} />
                    </MTabPanel>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#FFF'
    },

}))(MovieIndex));